import React, { useEffect, useState } from 'react';

import { getSitesPromise, simplifiedChannelsKeys } from '~/src/dash/api/channels';
import { ISite } from '~/src/dash/api/console-api';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';

// component handles the api call and generation of menu list for sites
// on top of the MaterialSearchDropdownMulti
interface IProps {
  name: string;
  onChange: (siteIDs: any[]) => void;
  publisherID: string;
  siteIDs: string[];
  // default false
  disabled?: boolean;
  // default true
  enableMultiSelect?: boolean;
  enableChangeWithFullSiteObject?: boolean;
}

export const SiteTargetingMultiSelect = function ({
  onChange,
  disabled = false,
  siteIDs = [],
  publisherID,
  enableMultiSelect = true,
  enableChangeWithFullSiteObject = false,
}: IProps) {
  const [siteMenuList, setSiteMenuList] = useState<IMenuList>({});

  async function loadSites() {
    try {
      const sites: ISite[] = await getSitesPromise({
        publisherIDs: [publisherID],
        publisherID,
        uiFields: [simplifiedChannelsKeys.ID, simplifiedChannelsKeys.NAME],
      }).then((sites: ISite[]) => sites);
      setSiteMenuList(buildSiteMenuList(sites, siteIDs, enableChangeWithFullSiteObject));
    } catch (e) {
      setSiteMenuList({});
    }
  }

  function handleMenuSelectionDone(values: IMenuList) {
    const siteIDs = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);
    const sites = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.site);
    if (enableChangeWithFullSiteObject) {
      onChange(sites);
    } else {
      onChange(siteIDs);
    }
  }

  useEffect(() => {
    loadSites();
  }, [publisherID]);

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={enableMultiSelect}
      menuTitle='Sites'
      list={siteMenuList}
      disabled={disabled}
      onChange={setSiteMenuList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      helperText={
        enableMultiSelect ? 'Choose which sites to target.' : 'Choose which site to target.'
      }
      enableMultiSelect={enableMultiSelect}
      width='400'
      showPrefixID
    />
  );
};

function buildSiteMenuList(
  sites: ISite[],
  selectedIDs: string[],
  enableChangeWithFullSiteObject: boolean,
): IMenuList {
  const list = {} as IMenuList;

  sites.forEach((site) => {
    list[site.ID] = {
      title: site.Name,
      ID: site.ID.toString(),
      selected: selectedIDs.includes(site.ID.toString()),
    } as IListItem;
    if (enableChangeWithFullSiteObject) {
      list[site.ID].site = site;
    }
  });
  return list;
}
